import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../utils/api';
import Card from '../../components/Common/Card';
import Button from '../../components/Common/Button';
import Input from '../../components/Common/Input';
import { showSuccess, showError } from '../../utils/swal';
import { User, Save, Lock } from 'lucide-react';

const Profile = () => {
  const { user, login } = useAuth(); // We'll just update state manully or re-fetch me. The auth context handles `me` on load. We can just dispatch an update or mutate window.location.reload() or we'll update context if there was a setUser.
  
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
    password_confirmation: ''
  });

  useEffect(() => {
    if (user) {
      setFormData(prev => ({
        ...prev,
        name: user.name || '',
        email: user.email || '',
        phone: user.phone || ''
      }));
    }
  }, [user]);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password && formData.password !== formData.password_confirmation) {
      showError('Şifreler eşleşmiyor');
      return;
    }

    setLoading(true);
    try {
      const response = await api.put('/me', formData);
      if (response.data.success) {
        showSuccess('Profil bilgileriniz güncellendi');
        // Clear passwords
        setFormData(prev => ({ ...prev, password: '', password_confirmation: '' }));
        // Optionally reload to update context
        window.location.reload(); 
      }
    } catch (error) {
       console.error('Profil güncelleme hatası', error);
       showError(error.response?.data?.message || 'Güncellenirken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <Card title={<div className="flex items-center gap-2"><User className="text-primary-600" size={24} /> Profil Bilgilerim</div>}>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Input 
              label="Ad Soyad"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <Input 
              label="E-posta"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <Input 
              label="Telefon (Opsiyonel)"
              name="phone"
              type="text"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>

          <div className="border-t border-gray-100 pt-6 mt-6">
            <h3 className="text-lg font-medium text-gray-900 mb-4 flex items-center gap-2">
              <Lock size={20} className="text-gray-500"/>
              Şifre Değiştirme (Opsiyonel)
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <Input 
                label="Yeni Şifre"
                name="password"
                type="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Değiştirmek istemiyorsanız boş bırakın"
                minLength={6}
              />
              <Input 
                label="Yeni Şifre (Tekrar)"
                name="password_confirmation"
                type="password"
                value={formData.password_confirmation}
                onChange={handleChange}
                placeholder="Yeni şifrenizi tekrar girin"
                minLength={6}
              />
            </div>
          </div>

          <div className="flex justify-end border-t border-gray-100 pt-6">
            <Button type="submit" disabled={loading}>
              <Save size={18} className="mr-2" />
              {loading ? 'Kaydediliyor...' : 'Değişiklikleri Kaydet'}
            </Button>
          </div>
        </form>
      </Card>
      
      {/* Read-Only Information */}
      <Card title="Departman ve Yetki Bilgileri">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
           <div className="bg-gray-50 p-3 rounded-lg border border-gray-100">
             <span className="text-gray-500 block mb-1">Departman</span>
             <span className="font-semibold text-gray-900">{user?.department?.name || 'Belirtilmemiş'}</span>
           </div>
           <div className="bg-gray-50 p-3 rounded-lg border border-gray-100">
             <span className="text-gray-500 block mb-1">Rol / Yetki Türü</span>
             <span className="font-semibold text-gray-900">
               {user?.role === 'office_owner' ? 'Ofis Sahibi' : user?.role === 'agent' ? 'Danışman' : 'Personel'}
               {user?.is_manager ? ' (Yönetici)' : ''}
             </span>
           </div>
           <div className="bg-gray-50 p-3 rounded-lg border border-gray-100">
             <span className="text-gray-500 block mb-1">Ofis Adı</span>
             <span className="font-semibold text-gray-900">{user?.office?.name || '-'}</span>
           </div>
           <div className="bg-gray-50 p-3 rounded-lg border border-gray-100">
             <span className="text-gray-500 block mb-1">Durum</span>
             <span className="font-semibold text-green-600">Aktif</span>
           </div>
        </div>
      </Card>
    </div>
  );
};

export default Profile;
